import salesKlassischServiceImage from "../assets/Images/sales-services/sales-klassisch-service.jpg";
import salesIndustrieServiceImage from "../assets/Images/sales-services/sales-industrie-service.jpg";
import salesHealthcareServiceImage from "../assets/Images/sales-services/sales-healthcare-service.jpg";
export const SALES_SERVICES = [
  {
    id: "sales-klassisch",
    title: "REPEXO Salespersonal klassisch",
    heroSubheading:
      "Headhunting von klassischen Vertriebsprofilen - vom Außendienst über Innendienst bis zum Key Account Management.",
    desc:
      "Headhunting von klassischen Vertriebsprofilen - vom Außendienst über Innendienst bis zum Key Account Management.",
    image: salesKlassischServiceImage,
    detail: {
      sections: [
        {
          leftLabel: "VERTRIEBS-HEADHUNTING",
          heading: "REPEXO Salespersonal klassisch",
          shortLabel: "Salesklassisch",
          paragraphs: [
            "Im Rahmen unserer Suchmethode Vertriebs-Headhunting Repexo Salespersonal klassisch suchen und identifizieren wir qualifizierte Vertriebs- und Verkaufsführungskräfte und Spezialisten aus Unternehmen und vergleichbaren Strukturen der Branchen unserer Kunden.",
            "Dabei arbeiten wir quer durch alle Industriebranchen, die kein hochkomplexes technisches Fachwissen der neuen Vertriebsmitarbeiter erfordern - in vielen Branchen und auf allen Ebenen.",
            "Echtes Headhunting ist die sicherste und effektivste Lösung, um genau die richtigen neuen Mitarbeiter für Ihr Unternehmen zu finden.",
          ],
        },
      ],
      cta: {
        heading: "Sprechen Sie mit uns - wir beraten Sie gern zu Ihrem Vertriebsbedarf.",
        buttonText: "Jetzt Kontakt aufnehmen",
        shortLabel: "Kontakt",
      },
    },
  },
  {
    id: "sales-industrie",
    title: "REPEXO Industrie Sales hochtechnisch",
    heroSubheading:
      "Vertriebspersönlichkeiten für erklärungsbedürftige, technische Produkte und Lösungen in B2B-Märkten.",
    desc:
      "Vertriebspersönlichkeiten für erklärungsbedürftige, technische Produkte und Lösungen in B2B-Märkten.",
    image: salesIndustrieServiceImage,
    detail: {
      sections: [
        {
          leftLabel: "TECHNISCHER VERTRIEB",
          heading: "REPEXO Industrie Sales hochtechnisch",
          shortLabel: "Industrie",
          paragraphs: [
            "Hochkomplexe und erklärungsbedürftige Verkaufsprodukte benötigen sehr technisch versierte Verkaufstalente aus den Branchen unserer Kunden.",
            "Hier setzen wir an und gewinnen für unsere Mandanten Vertriebsingenieure und IT-Fachvertriebsspezialisten aus vielen industriellen Segmenten.",
          ],
        },
      ],
      cta: {
        heading: "Sprechen Sie mit uns - wir beraten Sie gern zu Ihrem Vertriebsbedarf.",
        buttonText: "Jetzt Kontakt aufnehmen",
        shortLabel: "Kontakt",
      },
    },
  },
  {
    id: "sales-healthcare",
    title: "REPEXO Healthcare Sales",
    heroSubheading:
      "Sales- und Account-Profis für Pharma, Medizintechnik und Gesundheitsdienstleistungen.",
    desc:
      "Sales- und Account-Profis für Pharma, Medizintechnik und Gesundheitsdienstleistungen.",
    image: salesHealthcareServiceImage,
    detail: {
      sections: [
        {
          leftLabel: "HEALTHCARE SALES",
          heading: "REPEXO Healthcare Sales",
          shortLabel: "Healthcare",
          paragraphs: [
            "Der Erfolg unserer medizinischen Vertriebsspezialisierung bestätigt unsere Unternehmensleitlinien. Healthcare ist ein rechtlich, wirtschaftlich und aufgabenbezogen autonomes Feld.",
            "Es braucht dazu spezielle Branchenkenntnisse, um zeitnahe Leistungen auf höchstem Niveau zu erbringen.",
            "Wir finden für unsere Mandanten nicht nur Medizinprodukteberater, sondern hier paart sich medizinisches Fachwissen mit Verkaufstalent - für nachhaltige, vertrauensvolle Kundenbeziehungen.",
          ],
        },
      ],
      cta: {
        heading: "Sprechen Sie mit uns - wir beraten Sie gern zu Ihrem Vertriebsbedarf.",
        buttonText: "Jetzt Kontakt aufnehmen",
        shortLabel: "Kontakt",
      },
    },
  },
];


